import { Grid, GridCellProps, GridColumn as Column } from "@progress/kendo-react-grid";
import React, { useState } from "react"
import { Profile } from "../../../../services/profileService";
import { useMyProfileQuery } from "../../../../services/profileService/profile-api";
import { VobAssignmentRemoveCommand } from "./VobAssignmentRemoveCommand";
import { ColumnMenu } from "../../../../utils/ColumnMenu";
import CenterList from "../../../../services/orgService/model/CenterList";
import { Chip, IconButton, Stack, Tooltip } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { useAppDispatch } from "../../../../app/hooks";
import { openVobAssignmentEditModal } from "../../../../app/slices/ProfileModuleSlice";
import { VobAssignmentView } from "../../../../services/profileService/model/profile/VobAssignmentView";

type ownProps = {
    profile: Profile;
    centers: CenterList[];
}

function VobAssignmentsList(props: ownProps) {
    const { data } = useMyProfileQuery();
    const [profile] = useState(props.profile);
    const dispatch = useAppDispatch();

    const canAccess = (): boolean => {
        if (data?.role === 'Admin' || data?.role === 'RevCycle Admin' || data?.role === 'Incident Admin') {
            return true;
        }
        return false;
    }

    const customRemove = (cellProps: GridCellProps) => (<VobAssignmentRemoveCommand {...cellProps} profile={profile} />)

    const editCell = (cellProps: GridCellProps) => {
        const assignment = cellProps.dataItem as VobAssignmentView;
        return (
            <td>
                <Tooltip title="Edit assignment values">
                    <IconButton
                        size="small"
                        color="primary"
                        onClick={() => dispatch(openVobAssignmentEditModal(assignment))}
                    >
                        <EditIcon fontSize="small" />
                    </IconButton>
                </Tooltip>
            </td>
        );
    }

    const valuesCell = (cellProps: GridCellProps) => {
        const item = cellProps.dataItem;
        const values = item.assignmentValues || [];

        const getDisplayLabel = (value: string) => {
            if (item.assignmentTypeCode === 'Center') {
                const center = props.centers.find(c => c.code === value);
                return center ? `${center.code} - ${center.name}` : value;
            }
            return value;
        };

        return (
            <td>
                <Stack direction="row" spacing={0.5} flexWrap="wrap" gap={0.5}>
                    {values.map((val: string, index: number) => (
                        <Chip
                            key={index}
                            label={getDisplayLabel(val)}
                            size="small"
                            variant="outlined"
                        />
                    ))}
                </Stack>
            </td>
        );
    }

    return <React.Fragment>
        <Grid data={props.profile?.vobAssignments} style={{ height: '400px' }}>
            {canAccess() && <Column cell={editCell} width='60px' title='Edit' />}
            {canAccess() && <Column cell={customRemove} width='80px' title='Delete' />}
            <Column title='Type' field='assignmentTypeName' width='150px' columnMenu={ColumnMenu} />
            <Column title='Process' field='processTypeName' width='150px' columnMenu={ColumnMenu} />
            <Column title='Assigned Values' cell={valuesCell} />
        </Grid>
    </React.Fragment>
}

export default VobAssignmentsList;
